import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const OptionsWrapper = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 16px;
    list-style-type: none;
    margin: 24px 0px 0px 0px;
    width: 100%;
    max-width: 685px;
    max-height: 430px;
    overflow: auto;
    padding: 0px;
    align-items: stretch;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPure};
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highMedium};
      cursor: pointer;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${theme.v2.colors.neutral.highMedium};
    }
  `}
`;

export const ListItem = styled.li`
  ${({ theme }) => css`
    width: 100%;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      width: calc(50% - 16px);
      min-width: calc(50% - 16px);
    }

    &.checked{
      border-color: ${theme.v2.colors.brand.primaryBlue};
    }
  `};
`;

export const RadioLabel = styled.label`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const OptionRow = styled.div`
  ${() => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    button {
      padding: 2.5px;
    }
  `}
`;

export const OptionTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    margin: 0 0 0 10px;
    text-align: left;
  `};
`;

export const OptionDomainContainer = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    line-height: ${theme.v2.font.lineHeight.text};
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: 10px 0;
    margin: 0 0 0 10px;
    text-align: left;
  `};
`;

export const OptionDomainText = styled.strong``;

export const OptionDomain = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.v2.font.weights.regular};
    word-break: break-all;
  `};
`;
